import BaseDealerSelect from "@/vendor/Dealer/BaseDealerSelect.js";

class SampleDealerSelect extends BaseDealerSelect {
	showUI() {
		this.$scope.find('.dealer-select-sidebar').addClass('open');
	}

	close() {
		this.$scope.find('.dealer-select-sidebar').removeClass('open');
	}
}

export default new SampleDealerSelect({
	scope: '[data-find-dealer="scope"]',
	list: '[data-find-dealer="list"]',
	open: '[data-find-dealer="open"]',
	close: '[data-find-dealer="close"]',
	selectByMap: '[data-dealer-select]',
	selectByList: '[data-find-dealer="select-by-list"]',
	input: '[data-find-dealer="select-input"]',
	addressFields: [
		'[name="invoice_address[zipcode]"]',
		'[name="invoice_address[street]"]',
		'[name="invoice_address[street_number]"]',
		'[name="invoice_address[street_number_extra]"]',
		'[name="invoice_address[town]"]',
	],
	addressMap: {
		zipcode: "invoice_address[zipcode]",
		street: "invoice_address[street]",
		street_number: "invoice_address[street_number]",
		street_number_extra: "invoice_address[street_number_extra]",
		town: "invoice_address[town]",
	}
});